import { interactiveServiceFetch } from '../services/interactiveServiceFetch';
import { SLACK_AGENT_PATHS } from './constants';

export class SlackAgentApiError extends Error {
    constructor(status, detail) {
        super(`Slack agent API error ${status}: ${detail ?? 'unknown'}`);
        this.name = 'SlackAgentApiError';
        this.status = status;
        this.detail = detail;
    }
}

const extractDetail = body => {
    const detail = body?.detail;
    // FastAPI answers a request-validation failure with an array of {msg} entries, not a string.
    if (Array.isArray(detail)) return detail[0]?.msg ?? null;
    return typeof detail === 'string' ? detail : null;
};

const request = async (url, options) => {
    const response = await interactiveServiceFetch(url, options);
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new SlackAgentApiError(response.status, extractDetail(body));
    }
    if (response.status === 204) return null;
    return response.json();
};

const jsonOptions = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

const withParams = (path, params) => `${path}?${new URLSearchParams(params)}`;

export const fetchSlackAgentStatus = () => request(SLACK_AGENT_PATHS.STATUS);

export const startWorkspaceInstall = () => request(SLACK_AGENT_PATHS.INSTALL_START, { method: 'POST' });

export const startAccountLink = () => request(SLACK_AGENT_PATHS.LINK_START, { method: 'POST' });

export const fetchPendingLink = token => request(withParams(SLACK_AGENT_PATHS.LINK_CONFIRM, { token }));

export const confirmPendingLink = token => request(SLACK_AGENT_PATHS.LINK_CONFIRM, jsonOptions('POST', { token }));

export const unlinkSlackAccount = (teamId, slackUserId) =>
    request(withParams(SLACK_AGENT_PATHS.LINK, { team_id: teamId, slack_user_id: slackUserId }), { method: 'DELETE' });
